import * as React from "react";
import TableHeaderDaily from "./TableHeaderDaily";
import StudentRowDaily from "./StudentRowDaily";

const LearningResultsTableDaily = ({ classStageStudentList, activeFilter }) => {
    // activeFilter에 해당하는 학생 필터링
    const filteredStudents = classStageStudentList.filter((student) =>
        student.resultTags.includes(activeFilter) // resultTags에 activeFilter가 포함된 경우만 필터링
    );
    return (
        <div className="flex flex-col justify-center px-7 py-8 mb-32 mt-8 w-full bg-white rounded-3xl border border-solid border-zinc-300 shadow-[0px_2px_7px_rgba(0,0,0,0.1)] max-md:px-5 max-md:max-w-full">
            <table className="flex flex-col w-full rounded-none max-md:max-w-full table-auto">
                <TableHeaderDaily />
                {filteredStudents.length > 0 ? (
                    filteredStudents.map((student,index) => (
                        <StudentRowDaily key={index} index={index+1} {...student} />
                    ))
                ) : (
                    <tbody>
                        <tr className="flex flex-wrap text-center text-gray-500 py-5 w-full"><td className="text-center col-span-6 w-full">해당하는 학생이 없습니다.</td></tr>
                    </tbody>
                )}
            </table>
        </div>
    );
};

export default LearningResultsTableDaily;